/* eslint-disable sort-keys */
/* eslint-disable @typescript-eslint/member-ordering */
import { SectionProps } from "../../components/section/Section"

export interface FrontPageSectionProps {
  introProps: SectionProps
  blogsProps: SectionProps
  featuresProps: SectionProps
  getStartedProps: SectionProps
}

export const introSectionProps: SectionProps[] = [
  // Basic theme
  {
    backgroundColor: "white",
    bottomCut: {
      cutAngleLeftToRight: "downhill",
      nextSectionBackgroundColor: "roseGoldLight",
    },
  },
  // When blog section included
  {
    backgroundColor: "white",
    bottomCut: {
      cutAngleLeftToRight: "downhill",
      nextSectionBackgroundColor: "roseGold",
    },
  },
]

export const blogsSectionProps: SectionProps[] = [
  // Basic theme
  {
    backgroundColor: "roseGoldLight",
    bottomCut: {
      cutAngleLeftToRight: "downhill",
      nextSectionBackgroundColor: "roseGold",
    },
  },
  // When blog section included
  {
    backgroundColor: "roseGold",
    bottomCut: {
      cutAngleLeftToRight: "uphill",
      nextSectionBackgroundColor: "roseGoldLight",
    },
  },
]

export const featuresSectionProps: SectionProps[] = [
  // Basic theme
  {
    backgroundColor: "roseGoldLight",
    bottomCut: {
      cutAngleLeftToRight: "uphill",
      nextSectionBackgroundColor: "roseGold",
    },
  },
  // When blog section included
  {
    backgroundColor: "roseGoldLight",
    bottomCut: {
      cutAngleLeftToRight: "downhill",
      nextSectionBackgroundColor: "roseGold",
    },
  },
]

export const getStartedSectionProps: SectionProps[] = [
  // Basic theme
  {
    backgroundColor: "roseGold",
    bottomCut: {
      cutAngleLeftToRight: "downhill",
      nextSectionBackgroundColor: "yellow",
    },
  },
  // When blog section included
  {
    backgroundColor: "roseGold",
    bottomCut: {
      cutAngleLeftToRight: "uphill",
      nextSectionBackgroundColor: "yellow",
    },
  },
]

export const nextStepsSectionProps: SectionProps[] = [
  // Basic theme
  {
    backgroundColor: "yellow",
  },
]

export const getFrontPageSectionProps = (
  blogsIncluded: boolean,
): FrontPageSectionProps => {
  const option = blogsIncluded ? 1 : 0
  return {
    introProps: introSectionProps[option],
    blogsProps: blogsSectionProps[option],
    featuresProps: featuresSectionProps[option],
    getStartedProps: getStartedSectionProps[option],
  }
}
